import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { formIO, TFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";
import { TUuidObjectCodec, UuidObject } from "../Id";

export const DeleteProofOfFundsDocumentFormIO: TFormIOCodec<TUuidObjectCodec, TEmptyObjectCodec> = formIO(
    UuidObject,
    EmptyObject,
);

export type TDeleteProofOfFundsDocumentFormIOCodec = typeof DeleteProofOfFundsDocumentFormIO;
export type TDeleteProofOfFundsDocumentFormIO = TTypeOfCodec<TDeleteProofOfFundsDocumentFormIOCodec>;
